import DOMPurify from "dompurify";

const FORBIDDEN_TAGS = ["form", "base", "meta", "audio", "video"];

const FORBIDDEN_CONTENTS = [
  "script",
  "iframe",
  "object",
  "embed",
  "form",
  "svg",
  "math",
  "head",
  "template",
  "noscript",
  "noembed",
  "noframes",
  "title",
  "audio",
  "video",
  "plaintext",
  "xmp",
];

/**
 * Sanitiza HTML con DOMPurify.
 *
 * Por defecto también quita los estilos (bloques `<style>` y atributos
 * `style`). Con `keepStyles` los conserva, para mostrar un correo tal como lo
 * armó quien lo envió (con `FORCE_BODY`, porque un `<style>` al principio del
 * HTML iría a parar al `<head>` y se perdería); en ese caso quien lo llama
 * tiene que acotar esos estilos al contenedor del mensaje (ver
 * `prepareEmailHtml`).
 */
export function sanitizeHtml(html, { keepStyles = false } = {}) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    FORCE_BODY: keepStyles,
    FORBID_TAGS: keepStyles ? FORBIDDEN_TAGS : [...FORBIDDEN_TAGS, "style"],
    FORBID_ATTR: keepStyles ? [] : ["style"],
    FORBID_CONTENTS: keepStyles ? FORBIDDEN_CONTENTS : [...FORBIDDEN_CONTENTS, "style"],
  });
}
